type RegistroComStatus = Record<string, unknown>;

function normalizarStatus(valor: unknown): string {
  return String(valor ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();
}

/** Regra única para impedir cadastros inativos em seletores e pesquisas de vínculo. */
export function cadastroEstaAtivo(registro: unknown): boolean {
  if (!registro || typeof registro !== "object") return true;
  const item = registro as RegistroComStatus;
  const status = item.status ?? item.situacao;
  if (status !== undefined && status !== null && String(status).trim() !== "") {
    return !/^(INATIV|DESATIV|BLOQUEAD|EXCLUID)/.test(normalizarStatus(status));
  }

  const ativo = item.ativo ?? item.habilitado;
  if (ativo === undefined || ativo === null || String(ativo).trim() === "") return true;
  if (typeof ativo === "boolean") return ativo;
  if (typeof ativo === "number") return ativo !== 0;
  return !/^(0|N|NAO|FALSE|INATIV|DESATIV)$/.test(normalizarStatus(ativo));
}

export function somenteCadastrosAtivos<T>(registros: readonly T[]): T[] {
  return registros.filter((registro) => cadastroEstaAtivo(registro));
}
